import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.48792 7.33843C8.13913 6.48318 10.0142 6.00012 12 6.00012C13.9858 6.00012 15.8609 6.48318 17.5121 7.33843L19.6279 3.63574L21.3644 4.62802L19.2065 8.40426C22.1158 10.5926 24 14.076 24 18.0001V20.0001H0V18.0001C0 14.076 1.88416 10.5926 4.79347 8.40426L2.63562 4.62802L4.3721 3.63574L6.48792 7.33843ZM8.00391 13H6V15.0039H8.00391V13ZM18.0039 13H16V15.0039H18.0039V13Z"}}]};

const LogoAndroidFilled = Vue.extend<IconProps>({
  name: 'LogoAndroidFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-android-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoAndroidFilled;
